// extracted by mini-css-extract-plugin
export var quillEditor = "_nk-1";
export var variable = "_nk-0";